import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import { IPaymentsFilters } from "../types/payments.types";

export async function getPayments(filters: IPaymentsFilters) {
    const response = await axios.get(`/payments`, {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });

    return response.data;
}
